import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Markup } from 'interweave';
import { Link } from 'react-router-dom'
import classes from './Categories.module.css'

function Categories(props) {
    const [categs, setCategs] = useState([]);
    const [isVisible, setIsVisible] = useState(false);

    const toggleCats = () => {
        setIsVisible(!isVisible);
    }

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/categ.php`, {
            type: props.type
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            // console.log(res.data);
            setCategs(res.data);
        }).catch(err => {
            console.log(err);
        })
    }, []);

    return (
        <div className={`${classes.cats} ${classes.cats_fixed_right} ${isVisible ? classes.cats_visible : ''}`}>
            <span className={`${classes.cats_pull} opull-right`} onClick={() => toggleCats()}><i class="fa-solid fa-angle-right"></i></span>
            <div className={classes.cats_inner}>
                <ul>
                    {
                        categs && categs.map && categs.map((cats, index) => {
                            return(
                                <li>
                                    <Link className="cats-img" to={`/channel/${cats.nice_url}/${cats.id}/`} title={cats.name}>
                                        <img className="cats-img img-circle" src={cats.picture} alt={cats.name} />
                                    </Link>
                                    <Link className="cats-link" to={`/channel/${cats.nice_url}/${cats.id}/`} title={cats.name}><Markup content={cats.name}></Markup></Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
}

export default Categories